export const prodConfig = {
  amplitudeApiKey: '35d20378feefd7a445b950e6e0870690'
}
